import { Button, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Desc, Title } from "../../components/Desc";
import ProgressIndicator from "../../components/ProgressIndicator";
import strings from "../../config/localization";
import { useGetLocationDetailsQuery } from "../../services/appln";

interface DataType {
  key: string;
  locationId: string;
  designationId: string;
  name: string;
  kind: string;
  parent: string;
  designationName: string;
  assessmentId: number;
  assessmentCount: number;
  allocatedCount: number;
  status: string;
}

interface Data {
  rowData: DataType[];
  columnData: ColumnsType<DataType>;
}

export default function ListPersonnelAllocationsOfLocation() {
  console.log("ListPersonnelAllocationsOfLocation");
  const params = useParams();
  console.log("ListPersonnelAllocationsOfLocation, params:", params);
  const navigate = useNavigate();

  const bandobastContext = JSON.parse(localStorage.getItem("bandobast")!);
  const timeslotContext = JSON.parse(localStorage.getItem("timeslot")!);
  const locationContext = JSON.parse(localStorage.getItem("location")!);

  const [tableData, setTableData] = React.useState<Data>({
    rowData: [],
    columnData: [],
  });

  const locationsQueryResponse = useGetLocationDetailsQuery({
    bandobastId: params.bandobastId,
    timeslotId: params.timeslotId,
    locationId: params.locationId,
  });

  React.useEffect(() => {
    console.log(
      "ListPersonnelAllocationsOfLocation, response:",
      locationsQueryResponse,
    );
    if (!locationsQueryResponse.isSuccess) {
      return;
    }

    const rowData = locationsQueryResponse.data.data.map((e: any) => {
      const key = `${e.locationId}:${e.designationId}`;
      return {
        key: key,
        locationId: e.locationId,
        designationId: e.designationId,
        name: e.locationName,
        kind: e.locationKind,
        parent: "",
        designationName: e.designationName,
        assessmentCount: e.count,
        allocationCount: e.allocationCount,
        assessmentId: e.id,
        status:
          e.count === e.allocationCount ? strings.allocated : strings.pending,
      };
    });

    const designationNameSet = new Set<string>(
      rowData.map((e: DataType) => e.designationName),
    );

    const columns: ColumnsType<DataType> = [
      {
        title: strings.designation,
        dataIndex: "designationName",
        key: "designationName",
        width: 10,
        filters: Array.from(designationNameSet.keys())
          .sort()
          .map((e) => {
            return { text: e, value: e };
          }),
        onFilter: (value: any, record) => {
          return record.designationName === (value as string);
        },
      },
      {
        title: strings.allocatedCount,
        dataIndex: "allocationCount",
        key: "allocationCount",
        width: 2,
        render: (text, record, index) => (
          <Button
            onClick={() => {
              const toStore = {
                id: record.locationId,
                name: record.name,
                designationId: record.designationId,
                designationName: record.designationName,
                count: record.assessmentCount,
                assessmentId: record.assessmentId,
              };
              localStorage.setItem("location", JSON.stringify(toStore));
              navigate(
                `../personnelAllocation/${params.bandobastId}/${params.timeslotId}/${record.locationId}/${record.designationId}`,
              );
            }}
          >
            {text as string}
          </Button>
        ),
      },
    ];
    setTableData({
      rowData: rowData,
      columnData: columns,
    });
  }, [locationsQueryResponse]);

  console.log("ListPersonnelAllocationsOfLocation, tableData", tableData);

  return (
    <Box sx={{ flexGrow: 1, width: "100%" }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Title text={strings.personnelAllocationSummary} />
        </Grid>
        {(locationsQueryResponse.isLoading ||
          locationsQueryResponse.isFetching) && <ProgressIndicator />}

        <>
          <Grid item xs={12}>
            <Stack spacing={0}>
              <Desc label={strings.bandobast} value={bandobastContext.name} />
              <Desc label={strings.timeslot} value={timeslotContext.name} />
              <Desc label={strings.location} value={locationContext.name} />
            </Stack>
          </Grid>

          <Grid item xs={12}>
            <Table
              virtual
              scroll={{ y: 600 }}
              columns={tableData.columnData}
              dataSource={tableData.rowData.sort((a: any, b: any) => {
                return a.designationName.localeCompare(b.designationName);
              })}
              pagination={false}
            />
          </Grid>

          <Grid item xs={12}>
            <Button
              variant="contained"
              onClick={(e) => {
                e.preventDefault();
                navigate(-1);
              }}
            >
              {strings.back}
            </Button>
          </Grid>
        </>
      </Grid>
    </Box>
  );
}
